import { environment } from '@environments/environment';

export const API_ENDPOINT_NAME = {
  users: 'users',
  otp: 'otp',
  admin: 'admin',
  features: 'features',
  plans: 'plans',
  subscription: 'subscriptions',
  organizations: 'organizations',
  assisted: 'assisted',
  payment: 'payment',
  status: 'status',
};

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: `${environment.common_service}/${API_ENDPOINT_NAME.users}`,
    CHECK_EMAIL: `${environment.common_service}/${API_ENDPOINT_NAME.users}/email-status`,
    VERIFY_OTP: `${environment.common_service}/${API_ENDPOINT_NAME.otp}/verify`,
    SEND_OTP: `${environment.common_service}/${API_ENDPOINT_NAME.otp}/send`,
    RESEND_OTP: `${environment.common_service}/${API_ENDPOINT_NAME.otp}/resend`,
  },
  USERS: {
    BASE: `${environment.common_service}/${API_ENDPOINT_NAME.users}`,
    PROFILE: `${environment.common_service}/${API_ENDPOINT_NAME.users}/profile`,
    ADMIN: `${environment.common_service}/${API_ENDPOINT_NAME.users}/${API_ENDPOINT_NAME.admin}`,
    VIEW: (uid: string) => `${environment.common_service}/${API_ENDPOINT_NAME.users}/${uid}`,
    UPDATE: (uid: string) => `${environment.common_service}/${API_ENDPOINT_NAME.users}/${uid}`,
    GET_WORKFLOW_STATUS: `${environment.common_service}/${API_ENDPOINT_NAME.users}/getWorkflowStatus`,
  },
  ADMIN: {
    INCOMPLETE_LIST: `${environment.common_service}/${API_ENDPOINT_NAME.users}/getWorkflowStatus`,
  },
  FEATURES: {
    BASE: `${environment.subscription_service}/${API_ENDPOINT_NAME.features}`,
  },
  PLANS: {
    BASE: `${environment.subscription_service}/${API_ENDPOINT_NAME.plans}`,
  },
  MASTER: {
    REDIS_MASTER: `${environment.common_service}/redis/master`,
    PARENT_ORGANIZATION: `${environment.common_service}/organizations/parent`,
  },
  INQUIRIES: {
    LIST: `${environment.common_service}/inquiries/responses`,
  },
  TEMPLATES: {
    BASE: `${environment.core_service}/templates`,
    ID: (id: string) => `${environment.core_service}/templates/${id}`,
  },
  ORGANIZATION: {
    BASE: `${environment.common_service}/${API_ENDPOINT_NAME.organizations}`,
    ASSISTED: `${environment.common_service}/${API_ENDPOINT_NAME.organizations}/${API_ENDPOINT_NAME.assisted}`,
    UPDATE: (orgId: string) =>
      `${environment.common_service}/${API_ENDPOINT_NAME.organizations}/${orgId}`,
    LOGO: (orgId: string) =>
      `${environment.common_service}/${API_ENDPOINT_NAME.organizations}/${orgId}/logo`,
  },
  SUBSCRIPTION: {
    BASE: `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}`,
    CREATE: `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/${API_ENDPOINT_NAME.admin}`,
    ORDER_SUMMARY: `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/order/summary`,
    ADMIN_ORDER_SUMMARY: `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/order/summary/admin`,
    PAYMENT_CAPTURE: (customerId: string) =>
      `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/${customerId}/${API_ENDPOINT_NAME.payment}/${API_ENDPOINT_NAME.admin}`,
    GET_ACTIVE: (customerId: string) =>
      `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/${customerId}`,
    ACTIVATE: (customerId: string) =>
      `${environment.subscription_service}/${API_ENDPOINT_NAME.subscription}/${customerId}/${API_ENDPOINT_NAME.status}`,
  },
};
